"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComboboxInputMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _ComboboxAdditional = require("../../components/ComboboxAdditional/ComboboxAdditional.styles");
var _Icon = require("../../components/Icon/Icon.styles");
var _Input = require("../../components/Input/Input.styles");
var _Listbox = require("../../components/Listbox/Listbox.styles");
var _Tag = require("../../components/Tag/Tag.styles");
var _TagCloseButton = require("../../components/TagCloseButton/TagCloseButton.styles");
var _sizeMixin = require("../sizeMixin");
var _spaceMixin = require("../spaceMixin");
var _InputMixin = require("./InputMixin");
var _SelectMixin = require("./SelectMixin");
var errorCSS = function errorCSS(props) {
  if (!props.error) {
    return '';
  }
  return (0, _styledToken.default)({
    borderColor: 'Input.borderColorError'
  }, function (tokens) {
    return (0, _styledComponents.css)(["&&,&&:hover,&&:active,&&:focus-within{border-color:", ";}"], tokens.borderColor);
  })(props);
};
var focusCSS = function focusCSS(props) {
  if (props.disabled) {
    return '';
  }
  return (0, _styledToken.default)({
    focusShadow: 'ComboboxInput.boxShadow.focus',
    backgroundColor: 'Input.backgroundColorInteractive'
  }, function (_ref) {
    var focusShadow = _ref.focusShadow,
      backgroundColor = _ref.backgroundColor;
    return (0, _styledComponents.css)(["&:focus-within{box-shadow:", ";}&:focus-within,&:focus-within ", ",&:active ", "{background-color:", ";}"], focusShadow, _Input.StyledInput, _Input.StyledInput, backgroundColor);
  })(props);
};
var disabledCSS = function disabledCSS(props) {
  if (!props.disabled) {
    return '';
  }
  return (0, _styledToken.default)({
    opacity: 'ComboboxInput.TagCloseButton.opacity.disabled',
    cursor: 'ComboboxInput.TagCloseButton.cursor.disabled'
  }, function (_ref2) {
    var _ref2$opacity = _ref2.opacity,
      opacity = _ref2$opacity === void 0 ? 1 : _ref2$opacity,
      _ref2$cursor = _ref2.cursor,
      cursor = _ref2$cursor === void 0 ? 'default' : _ref2$cursor;
    return (0, _styledComponents.css)(["", "{opacity:", ";cursor:", ";}"], _TagCloseButton.StyledTagCloseButton, opacity, cursor);
  })(props);
};
var paddingRightCSS = function paddingRightCSS(props) {
  var appearance = props.appearance,
    isClearable = props.isClearable;
  return (0, _styledToken.default)({
    chevronWidth: 'Select.chevronWidth',
    horizontalSpacing: 'Input.horizontalSpacing',
    closeButtonSize: 'Tag.closeButtonSize',
    closeButtonMargin: 'Tag.targetPadding',
    basePaddingSize: 'ComboboxInput.select.basePaddingSize'
  }, function (tokens) {
    /**
     * Padding for appearance of "select" vs. "input"
     * Adds extra padding for the chevron
     * @see SelectMixin.js
     */
    var basePadding = appearance === 'select' ? (0, _spaceMixin.spaceMixin)(tokens.basePaddingSize, function (space) {
      return space.value + tokens.chevronWidth;
    })(props) : tokens.horizontalSpacing;

    // Adds extra padding to cover the clear button
    var clearablePadding = isClearable ? tokens.closeButtonSize + tokens.closeButtonMargin : 0;
    return (0, _styledComponents.css)(["padding-right:", "px;"], basePadding + clearablePadding);
  })(props);
};
var ComboboxInputMixin = function ComboboxInputMixin(props) {
  var appearance = props.appearance,
    disabled = props.disabled,
    expanded = props.expanded,
    size = props.size;
  var isSelect = appearance === 'select';
  return (0, _styledToken.default)({
    borderWidth: 'Input.borderWidth',
    chevronWidth: 'Select.chevronWidth',
    fontType: 'Input.fontType',
    tagMargin: 'ComboboxInput.tagMargin',
    tagPadding: 'Tag.verticalPadding',
    closeButtonSize: 'Tag.closeButtonSize',
    closeButtonMargin: 'Tag.targetPadding',
    horizontalSpacing: 'Input.horizontalSpacing',
    minInputWidth: 'ComboboxInput.minInputWidth',
    listboxBorder: 'ComboboxInput.ListboxBorder.border',
    inputBorder: 'ComboboxInput.Input.border',
    inputPadding: 'ComboboxInput.Input.padding',
    inputShadow: 'ComboboxInput.Input.boxShadow'
  }, function (_ref3) {
    var borderWidth = _ref3.borderWidth,
      chevronWidth = _ref3.chevronWidth,
      fontType = _ref3.fontType,
      tagMargin = _ref3.tagMargin,
      tagPadding = _ref3.tagPadding,
      closeButtonSize = _ref3.closeButtonSize,
      horizontalSpacing = _ref3.horizontalSpacing,
      minInputWidth = _ref3.minInputWidth,
      listboxBorder = _ref3.listboxBorder,
      _ref3$inputBorder = _ref3.inputBorder,
      inputBorder = _ref3$inputBorder === void 0 ? 0 : _ref3$inputBorder,
      _ref3$inputPadding = _ref3.inputPadding,
      inputPadding = _ref3$inputPadding === void 0 ? 0 : _ref3$inputPadding,
      _ref3$inputShadow = _ref3.inputShadow,
      inputShadow = _ref3$inputShadow === void 0 ? 'none' : _ref3$inputShadow;
    return (0, _styledComponents.css)(["", " ", " ", " ", " ", " position:relative;display:flex;flex-wrap:wrap;align-items:center;&&{cursor:", ";}", " ", "{border:", ";padding:", ";box-shadow:", ";flex:1 0 ", ";padding-top:", "px;padding-bottom:", "px;opacity:1;}> ", "{position:absolute;right:", "px;top:calc(50% - ", "px);", "{box-shadow:none;}}", "{margin-right:", "px;margin-top:", "px;margin-bottom:", "px;cursor:default;&:last-of-type{margin-right:", "px;}}", " + ", "{margin-left:-", "px;margin-right:", "px;}", "{border:", ";}"], isSelect ? (0, _SelectMixin.SelectMixin)(Object.assign({}, props, {
      'aria-expanded': "" + expanded
    })) : (0, _InputMixin.InputMixin)(props), paddingRightCSS(props), focusCSS(props), errorCSS(props), disabledCSS(props), disabled ? 'default' : 'text', (0, _sizeMixin.sizeMixin)({
      fontType: fontType,
      borderWidth: borderWidth * 2 + tagMargin + tagPadding * 2,
      size: size
    })(props), _Input.StyledInput, inputBorder, inputPadding, inputShadow, minInputWidth, tagMargin / 2 + tagPadding, tagMargin / 2 + tagPadding, _TagCloseButton.StyledTagCloseButton, isSelect ? chevronWidth : horizontalSpacing, closeButtonSize / 2, _Icon.StyledIcon, _Tag.StyledTag, tagMargin, tagMargin / 2, tagMargin / 2, horizontalSpacing, _Tag.StyledTag, _ComboboxAdditional.StyledComboboxAdditional, horizontalSpacing - tagMargin, horizontalSpacing, _Listbox.StyledListbox, listboxBorder);
  })(props);
};
exports.ComboboxInputMixin = ComboboxInputMixin;